export class Alert {
	id: number;
	username: string;
	title: string;
	body: string;
	unread: boolean;
	created: Date;
	edited: Date;
}